import { formatScreenshotTimestamp } from '../utils/date';

export default ({ headers, baseUrl, bankId, caseInfo }) => ({
  getQuestions: () => ({
    uri: `${baseUrl}/banks/${bankId}/cases/${caseInfo.type}/${caseInfo.id}/verify/challenge`,
    headers
  }),
  submitAnswers: answers => ({
    uri: `${baseUrl}/banks/${bankId}/cases/${caseInfo.type}/${caseInfo.id}/verify/submit`,
    method: 'PUT',
    body: JSON.stringify({ challenges: answers }),
    headers
  }),
  attachEvidence: (context, screenshot) => ({
    uri: `${baseUrl}/banks/${bankId}/cases/${caseInfo.type}/${caseInfo.id}/evidence`,
    method: 'POST',
    body: JSON.stringify({
      context,
      capture_timestamp: formatScreenshotTimestamp(),
      image: {
        mime_type: 'image/jpeg',
        data: [screenshot]
      }
    }),
    headers
  })
});
